/**
 * Created by Kevin Dench on 7/25/2016.
 */
/* @ngInject */
export default function OctopartApiService($resource, __env, $http, PartNumberFormatterService) {
    'use strict';

    return {
        getOctopartDistInfoByCountry: function (uniquePart, country, callBack) {
            const octopartRequest = {
                'uniquePn': uniquePart.uniquePn,
                'superAlias': uniquePart.superAlias,
                'aliases': uniquePart.aliases
            };
            $http.post(
                `${__env.intellidataApiUrl}octopart/parts?countryCode=` + country,
                octopartRequest
            ).then(({data}) => {
                callBack(data);
            });
        },
        getOctopartDistInfo: function (uniquePart, callBack) {
            const octopartRequest = {
                'uniquePn': uniquePart.uniquePn,
                'superAlias': uniquePart.superAlias,
                'aliases': uniquePart.aliases
            };
            $http.post(
                `${__env.intellidataApiUrl}octopart/parts`,
                octopartRequest
            ).then(({data}) => {
                callBack(data);
            });
        },
        getCountries: function (callBack) {
            $resource(
                `${__env.intellidataApiUrl}octopart/countries`
            ).get(callBack);
        },

        /**
         * Get Octopart Quantities
         *
         * @description this function takes in a list of unique parts, and applies some business logic
         * to the parts that are passed in; all of this in order to prepare the request for Octopart.
         *
         * @param uniqueParts
         * @param callBack
         *
         * @returns {function}
         */
        getOctoPartQuantities: function (uniqueParts, callBack) {
            const octoPartRequests = [];
            uniqueParts.forEach(function (uniquePart) {
                const aliasesToSend = [];
                let uniquePn = '';
                if (uniquePart.superAlias !== null && uniquePart.superAlias !== undefined) {
                    if (uniquePart.aliases !== undefined && uniquePart.aliases.length > 0) {
                        aliasesToSend.push(
                            {value: uniquePart.uniquePn, displayable: true},
                            PartNumberFormatterService.formatAliasValue(uniquePart.aliases[0]),
                            PartNumberFormatterService.formatAliasValue(uniquePart.aliases[1])
                        );
                    }
                    uniquePn = uniquePart.superAlias;
                } else {
                    if (uniquePart.aliases !== undefined && uniquePart.aliases.length > 0) {
                        aliasesToSend.push(
                            PartNumberFormatterService.formatAliasValue(uniquePart.aliases[0]),
                            PartNumberFormatterService.formatAliasValue(uniquePart.aliases[1])
                        );
                    }
                    uniquePn = uniquePart.uniquePn;
                }

                octoPartRequests.push({
                    'uniquePn': PartNumberFormatterService.formatPn(uniquePn),
                    'aliases': aliasesToSend
                });
            });
            $http.post(
                `${__env.intellidataApiUrl}octopart/quantities`,
                octoPartRequests
            ).then(({data}) => {
                callBack(data);
            });
        }
    };
}
